import React, { FC, useState } from 'react'
import Select from 'react-select'
import SelectorStyles from '../../../../../../../constants/selectorStyles'
import { useUserFeedback } from '../../../../../context'

export const SelectQuestionType: FC<{
  questionCallback: (value: string) => void
  value?: string
}> = ({ questionCallback, value }) => {
  const { questionTypeLabels } = useUserFeedback()
  const [questionType, setQuestionType] = useState(questionTypeLabels.find(opt => opt.value === value))

  const changeQuestionType = (questionType: { value: string; label: string }) => {
    setQuestionType(questionType)
    questionCallback(questionType.value)
  }

  return (
    <Select
      styles={{
        ...SelectorStyles,
        menuPortal: base => ({ ...base, zIndex: 9999 }),
      }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      options={questionTypeLabels}
      placeholder="Select question type"
      onChange={changeQuestionType}
      value={questionType}
    />
  )
}
